import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'content-info',
})

export default class ContentInfoComponent extends Vue {

    @Prop()
    public providerList: any;

    public defaultListIds: any = [463, 474, 446, 485, 522];

    // --------------------------------------------------------
    // Properties

    @Prop()
    private contentList: any;

    @Prop()
    private productData: any;

    private publisherList: any = [];

    private providerOriginalList: any = [];

    private activePublisher: any = null;

    private searchTerms: string = '';

    @Watch('contentList')
    private watchContentList() {
        this.loadProductDetails();
        this.setProduct();
    }

    @Watch('productData')
    private onWatchContent() {
        this.activePublisher = this.productData;
    }

    // --------------------------------------------------------
    // Hooks

    private created() {
        this.loadProductDetails();
        this.setProduct();
    }

    private setProduct() {
      const allList: any = [];
      this.defaultListIds.map((list: any) => {
        const filterList = this.providerList.find((item: any) => item.id === list);
        if (filterList) {
          allList.push(filterList);
        }
      });
      this.publisherList = allList;
      this.providerOriginalList = allList;
    }

    private activated() {
        this.activePublisher = this.productData;
    }

    // --------------------------------------------------------
    // Actions

    private onSelectPublisher(publisher: any) {
        this.activePublisher = publisher === this.activePublisher ? null : publisher;
        this.$emit('onSelectProduct', this.activePublisher);
    }

    private onSearchProduct() {
        const searchTerms = this.searchTerms;
        const contentList = this.contentList.subscribedTools || [];
        const list = this.providerOriginalList;
        const term = searchTerms.toLowerCase();
        const providerList = list.filter((item: any) => (item.name.toLowerCase()).startsWith(term));
        this.publisherList = providerList;
    }

    // --------------------------------------------------------
    // Methods

    private loadProductDetails() {
        const contentList = this.contentList.subscribedTools || [];
        this.publisherList = contentList.filter((item: any) => item.status === 'active');
    }


}
